import { TREBLE_TOWN_MAP, SECRET_WORD } from "../data/chapters";

const KEY_PROGRESS = "TT_PROGRESS_BY_CHAPTER";
const KEY_LETTERS  = "TT_LETTERS_EARNED"; // { [chapter]: true }

export function getChapterMeta(ch) {
  return TREBLE_TOWN_MAP.find(c => c.chapter === ch);
}

export function loadProgress() {
  try { return JSON.parse(localStorage.getItem(KEY_PROGRESS)) || {}; }
  catch { return {}; }
}

export function saveProgress(obj) {
  localStorage.setItem(KEY_PROGRESS, JSON.stringify(obj || {}));
}

export function markChapterComplete(ch) {
  const p = loadProgress();
  p[ch] = true;
  saveProgress(p);
  return p;
}

export function loadLetters() {
  try { return JSON.parse(localStorage.getItem(KEY_LETTERS)) || {}; }
  catch { return {}; }
}

export function saveLetters(obj) {
  localStorage.setItem(KEY_LETTERS, JSON.stringify(obj || {}));
}

export function markLetterEarned(ch) {
  const l = loadLetters();
  l[ch] = true;
  saveLetters(l);
  return l;
}

export function hasEarnedLetter(ch) {
  const l = loadLetters();
  return !!l[ch];
}

export function getCollectedLetters(progressByChapter = loadProgress()) {
  return TREBLE_TOWN_MAP
    .filter(c => c.letter && progressByChapter[c.chapter])
    .sort((a,b) => a.letterIndex - b.letterIndex)
    .map(c => c.letter)
    .join("");
}

export function isSecretComplete() {
  return getCollectedLetters() === SECRET_WORD;
}

export function getSkillTotals(progressByChapter = loadProgress()) {
  const total = TREBLE_TOWN_MAP.reduce((s, c) => s + (c.skillPoints || 0), 0);
  const earned = TREBLE_TOWN_MAP.reduce((s, c) => s + ((progressByChapter[c.chapter] ? c.skillPoints : 0) || 0), 0);
  return { earned, total };
}
